/* eslint-disable @typescript-eslint/no-unsafe-return */
// https://stash.odp.cba/projects/DP/repos/homeinsuranceclaims/browse/src/app/
// HomeInsuranceClaims.Web.Frontend/src/scripts/utils/animationFrame.ts

const getAnimationFrame = (): ((callback: FrameRequestCallback) => number) => {
  // Check if requestAnimationFrame can be used for the browser
  // Otherwise, default to use a timeout
  if (typeof requestAnimationFrame !== 'undefined') {
    return requestAnimationFrame;
  }
  if (typeof window !== 'undefined' && typeof window.requestAnimationFrame !== 'undefined') {
    return window.requestAnimationFrame;
  }

  // Webkit animation
  if (typeof (window as any).webkitRequestAnimationFrame !== 'undefined') {
    return (window as any).webkitRequestAnimationFrame;
  }
  if (
    typeof window !== 'undefined'
    && typeof (window as any).webkitRequestAnimationFrame !== 'undefined'
  ) {
    return (window as any).webkitRequestAnimationFrame;
  }

  // Use timeout
  if (typeof window !== 'undefined' && typeof window.setTimeout !== 'undefined') {
    return (callback: FrameRequestCallback): number => window.setTimeout(callback, 1000 / 60);
  }

  // Unable to handle animation
  return (callback: FrameRequestCallback): number => {
    callback(0);
    return 1;
  };
};

export const animationFrame = getAnimationFrame();
